import { render, staticRenderFns } from "./ItemDetail.vue?vue&type=template&id=4782aaee&scoped=true&"
import script from "./ItemDetail.vue?vue&type=script&lang=js&"
export * from "./ItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItemDetail.vue?vue&type=style&index=0&id=4782aaee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4782aaee",
  null
  
)

export default component.exports